/**
 * @flow
 * @relayHash a2b1422cb8b47f2e8dee9c248bac97b3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
export type ConfigurableBlockEditInput = {
  id: string,
  type: ConfigurableBlockType,
  slug?: ?string,
  config?: ?any,
  clientMutationId?: ?string,
};
export type ConfigurableBlockEditMutationVariables = {|
  input: ConfigurableBlockEditInput
|};
export type ConfigurableBlockEditMutationResponse = {|
  +ConfigurableBlockEdit: ?{|
    +error: ?string,
    +edge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type ConfigurableBlockEditMutation = {|
  variables: ConfigurableBlockEditMutationVariables,
  response: ConfigurableBlockEditMutationResponse,
|};
*/


/*
mutation ConfigurableBlockEditMutation(
  $input: ConfigurableBlockEditInput!
) {
  ConfigurableBlockEdit(input: $input) {
    error
    edge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfigurableBlockEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ConfigurableBlockEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ConfigurableBlockEditInput!"
      }
    ],
    "concreteType": "ConfigurableBlockEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edge",
        "storageKey": null,
        "args": null,
        "concreteType": "ConfigurableBlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ConfigurableBlockEditMutation",
  "id": null,
  "text": "mutation ConfigurableBlockEditMutation(\n  $input: ConfigurableBlockEditInput!\n) {\n  ConfigurableBlockEdit(input: $input) {\n    error\n    edge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ConfigurableBlockEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfigurableBlockEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '30a28e1705055484f16420731108f200';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/__generated__/ConfigurableBlockEditMutation.graphql.js